import {Button} from "@/components/ui/Button";
import {
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import {Dialog} from "@/components/ui/dialog";
import {DialogContent} from "@/components/ui/dialog";
import {Icon} from "@/components/ui/icon";
import {TriangleAlert} from "lucide-react";

export const ResetModal = ({
  onReset,
  showModal,
  setShowModal,
}: {
  onReset: () => void;
  showModal: boolean;
  setShowModal: (showModal: boolean) => void;
}) => {
  const handleReset = () => {
    onReset && onReset();
    setShowModal(false);
  };

  return (
    <Dialog open={showModal} onOpenChange={setShowModal}>
      <DialogContent className="w-110 min-w-110 block overflow-hidden">
        <DialogHeader className="sr-only">
          <DialogTitle>Reset All Changes in Edit Mode?</DialogTitle>
        </DialogHeader>
        <DialogDescription className="sr-only">
          By agreeing, you will reset all changes made in edit mode and revert
          to the current live version.
        </DialogDescription>
        <div className="bg-white p-6 rounded-lg w-110 flex flex-col items-center gap-5">
          <Icon className="bg-red-50 border-red-100 rounded-lg" size="lg">
            <TriangleAlert size={28} className="text-red-500" />
          </Icon>
          <div className="flex flex-col items-center gap-2 text-center">
            <h2 className="text-lg font-bold">
              Reset All Changes in Edit Mode?
            </h2>
            <p className="text-sm text-label">
              By agreeing, you will reset all changes made in edit mode and
              revert to the current live version.
            </p>
          </div>
          <div className="flex justify-between w-full gap-3">
            <Button
              onClick={() => setShowModal(false)}
              variant="outline"
              className="w-1/2"
            >
              No, Return to Flow
            </Button>
            <Button
              onClick={handleReset}
              variant="outline-destructive"
              className="w-1/2"
            >
              Yes, Reset
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
